function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_calendar");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25,20.31h41.5a0,0,0,0,1,0,0V46.37a5.4,5.4,0,0,1-5.4,5.4H16.65a5.4,5.4,0,0,1-5.4-5.4V20.31A0,0,0,0,1,11.25,20.31Z",
  fill: "#e5daca",
  stroke: "#e5daca",
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6,12H47.4A5.6,5.6,0,0,1,53,17.6v3.9a0,0,0,0,1,0,0H11a0,0,0,0,1,0,0V17.6A5.6,5.6,0,0,1,16.6,12Z",
  fill: "#5cb3b1",
  stroke: "#5cb3b1",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 24.5,
  width: 5,
  height: 5,
  rx: 1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 24.5,
  width: 5,
  height: 5,
  rx: 1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 33,
  width: 5,
  height: 5,
  rx: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 33,
  width: 5,
  height: 5,
  rx: 1
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 42,
  width: 5,
  height: 5,
  rx: 1
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 24.5,
  y: 42,
  width: 5,
  height: 5,
  rx: 1
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 24.5,
  width: 5,
  height: 5,
  rx: 1
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 44.5,
  y: 24.5,
  width: 5,
  height: 5,
  rx: 1
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 33,
  width: 5,
  height: 5,
  rx: 1
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 44.5,
  y: 33,
  width: 5,
  height: 5,
  rx: 1
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 34.5,
  y: 42,
  width: 5,
  height: 5,
  rx: 1
});

var SvgIconCalendar = function SvgIconCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-calendar.5cdec249.svg";
export { ForwardRef as ReactComponent };